import styles from "./styles/PosShoppingCart.module.css";
import InputText from "../../../components/ui/input_text/InputText";
import InputTextArea from "../../../components/ui/input_text_area/InputTextArea";
import { t } from "i18next";
import SliderToggle from "../../../components/ui/slider_toggle/SliderToggle";
import { useEffect, useState } from "react";
import { stringTrim } from "../../../utils/utils";

const PosCashForm = ({
    CASH_REFERENCE,
    handleChange, // {Function} - Function to handle input changes
    formInput, // {Object} - The current form input values
    hoverFlag, // {Boolean} - Indicates if the hover flag is active
    MONEY_ORDER_PREFIX,
}) => {
    const [cashReferenceValue, setCashReferenceValue] = useState("");
    const isMoneyOrder = !!formInput?.isMoneyOrder;
    const prefix = MONEY_ORDER_PREFIX || "";

    useEffect(() => {
        const v = formInput?.cashReference ?? "";

        if (!formInput?.isMoneyOrder) {
            setCashReferenceValue(v);
        } else if (!v) {
            setCashReferenceValue(prefix);
        } else if (v.startsWith(prefix)) {
            setCashReferenceValue(v);
        } else {
            setCashReferenceValue(prefix + v);
        }
    }, [formInput?.isMoneyOrder, formInput?.cashReference]);

    const toggleSlider = (event) => {
        setCashReferenceValue("");
        handleChange({
            target: { name: "cashReference", value: "" },
        });

        handleChange({
            target: { name: event.target.name, value: event.target.checked },
        });
    };

    const handleMoneyOrderChange = (event) => {
        const { name, value } = event.target;
        const prefixLen = prefix.length;
        let newValue = value;
        if (value.length < prefixLen && prefix.startsWith(value)) {
            // Lock the prefix, no suffix
            newValue = prefix;
        } else if (!value.startsWith(prefix)) {
            // Try to recover "suffix"
            const idx = value.indexOf(prefix);
            let suffix = "";

            if (idx !== -1) {
                // If prefix appears later in the string, use what comes after it
                suffix = value.slice(idx + prefixLen);
            } else {
                // No prefix at all: treat whole thing as suffix
                suffix = value;
            }

            newValue = prefix + suffix;
        }
        // 3) Normal editing after the prefix — accept as is
        else {
            newValue = value;
        }

        handleChange({
            target: { name, value: newValue },
        });
    };

    return (
        <div
            className={`${styles.payment_input_container} ${styles.input_form_data} v-flex-container `}
        >
            <div className={`${styles.slider_container} flex-container `}>
                <SliderToggle
                    inputId={"isMoneyOrder"}
                    inputValue={formInput?.isMoneyOrder}
                    onClickFunction={toggleSlider}
                    rightLabel={"money order"}
                />
            </div>

            <div className={`${styles.payment_input_container} `}>
                <InputText
                    label={
                        formInput?.isMoneyOrder
                            ? t("money order number")
                            : t("external reference")
                    }
                    inputId={"cashReference"}
                    inputValue={cashReferenceValue}
                    handleChangeFunction={
                        formInput?.isMoneyOrder
                            ? handleMoneyOrderChange
                            : handleChange
                    }
                    required={
                        hoverFlag &&
                        formInput?.isMoneyOrder &&
                        !stringTrim(
                            formInput?.cashReference.slice(
                                MONEY_ORDER_PREFIX.length,
                            ),
                        )
                    }
                    placeholder={`${t("required")}!`}
                    standardPlaceholder={
                        formInput?.isMoneyOrder ? "" : t(CASH_REFERENCE)
                    }
                    textAlign={"left"}
                    type={"text"}
                    fullWidth={true}
                />
            </div>
            <div
                className={`${styles.payment_input_container} ${styles.payment_comment}  flex-container`}
            >
                <InputTextArea
                    label={t("comments")}
                    inputId={"comment"}
                    inputValue={formInput?.comment}
                    handleChangeFunction={handleChange}
                    textAlign={"left"}
                    type={"text"}
                    fullWidth={true}
                />
            </div>
        </div>
    );
};

export default PosCashForm;
